import permissions from 'constants/permissions'

const ORGANIZATION_LIST = [
  {
    name: 'Gerenciar',
    tag: permissions.ORGANIZATION.MANAGE,
  },
  {
    name: 'Visualizar usuários',
    tag: permissions.ORGANIZATION_USER.VIEW,
  },
  {
    name: 'Gerenciar usuários',
    tag: permissions.ORGANIZATION_USER.MANAGE,
  },
]

export default ORGANIZATION_LIST
